var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oui:arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0694 5.15711L8.38444 9.76811C8.28221 9.86924 8.14423 9.92596 8.00044 9.92596C7.85664 9.92596 7.71866 9.86924 7.61644 9.76811L2.93144 5.15811C2.82858 5.05703 2.69014 5.0004 2.54594 5.0004C2.40173 5.0004 2.26329 5.05703 2.16044 5.15811C2.10979 5.20749 2.06954 5.2665 2.04205 5.33168C2.01457 5.39686 2.00041 5.46688 2.00041 5.53761C2.00041 5.60834 2.01457 5.67836 2.04205 5.74354C2.06954 5.80872 2.10979 5.86773 2.16044 5.91711L6.84444 10.5271C7.15296 10.83 7.56806 10.9998 8.00044 10.9998C8.43281 10.9998 8.84791 10.83 9.15644 10.5271L13.8404 5.91711C13.8912 5.86772 13.9316 5.80864 13.9592 5.74337C13.9868 5.6781 14.001 5.60797 14.001 5.53711C14.001 5.46626 13.9868 5.39612 13.9592 5.33085C13.9316 5.26558 13.8912 5.2065 13.8404 5.15711C13.7376 5.05603 13.5991 4.9994 13.4549 4.9994C13.3107 4.9994 13.1723 5.05603 13.0694 5.15711Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f80c561062a9622ad72dc7651390591d.svg";
export { ForwardRef as ReactComponent };